import { render, staticRenderFns } from "./stockinput.vue?vue&type=template&id=b13ad006&scoped=true&"
import script from "./stockinput.vue?vue&type=script&lang=js&"
export * from "./stockinput.vue?vue&type=script&lang=js&"
import style0 from "./stockinput.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stockinput.vue?vue&type=style&index=1&id=b13ad006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13ad006",
  null
  
)

export default component.exports